export class SaveCart {
    constructor() {
        this.handle = async (cart) => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/cart`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(cart),
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
